/**
 * @type {BD_CFG}
 */
const CONFIG = {
    restURL: window.CFG?.restURL ?? "",
    themeURL: window.CFG?.themeURL ?? "",
    firebase: window.CFG?.firebase ?? {
        key: "",
        auth_domain: "",
        database_url: "",
        auth_token: "",
        team_code: "",
        environment: "",
    },
    game: window.CFG?.game ?? {
        id: "",
        isFinish: false,
        timeLeft: 0,
        is_leader: false,
        timeLimit: 0,
        isStarted: false,
        roundTimer: [],
        rounds: [],
        fossilEnergy: {
            current: 0,
            initial: 0,
            barLength: 0,
        },
        tasks: [],
        firstRound: {
            id: 0,
            time_round: "",
            task_amount: 0,
        },
        point: 0,
        usedGreenEnergyPercentage: 0,
    },
    isAuth: window.CFG?.isAuth ?? 0,
    nonce: window.CFG?.nonce ?? "",
    siteURL: window.CFG?.siteURL ?? "",
    user: window.CFG?.user ?? {
        id: 0,
        avatar: "",
        nickname: "",
        email: "",
    },
   
};

export default CONFIG;
